import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

@Component({
	selector: 'app-resend-intake-dialog',
	templateUrl: './resend-intake.dialog.html',
	styleUrl: './resend-intake.dialog.scss',
	imports: [
		CommonModule,
		MatDialogContent,
		MatDialogActions,
		MatButtonModule,
		MatDialogTitle,
		MatDialogClose
	],
})
export class ResendIntakeDialog {
	constructor(
		public dialogRef:MatDialogRef<ResendIntakeDialog>,
		@Inject(MAT_DIALOG_DATA) public data:{ title:string }
	) {
	}
}
